<template>
  <div class="page_container userListPage">
    <div class="main_container">
      <template v-if="USERINFO.qy">
        <el-tabs v-model="activeName" @tab-click="handleTab">
          <el-tab-pane label="基础用户数据" name="first">
            <div class="flex-rowr" style="padding-bottom: 15px">
              <el-button
                type="primary"
                @click="handleDownload"
                v-if="tabListOne.length > 0"
                >下载用户数据</el-button
              >
              <!-- <a :href="downloadUrl" download style="color: #fff;">下载用户数据</a> -->
            </div>
            <el-table
              :data="tabListOne"
              height="55vh"
              style="width: 100%"
              v-loading="loading"
              element-loading-text="加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(0, 0, 0, 0.4)"
            >
              <!-- <el-table-column
              prop="accountid"
              label="用户账户ID"
              width="200"
            >
            </el-table-column> -->
              <el-table-column prop="truename" label="姓名"> </el-table-column>
              <el-table-column prop="mobile" label="手机号"> </el-table-column>
              <el-table-column prop="score" label="普通用户积分">
              </el-table-column>
              <el-table-column prop="levelidstr" label="用户等级">
              </el-table-column>
              <el-table-column prop="usertypestr" label="用户类型">
              </el-table-column>
              <el-table-column prop="attrstr" label="用户属性">
              </el-table-column>
              <el-table-column prop="validorders" label="有效订单数量">
              </el-table-column>
              <!-- <el-table-column prop="score2" label="商务用户积分">
            </el-table-column>
            <el-table-column prop="account" label="现金账户余额">
            </el-table-column> -->
              <el-table-column label="用户注册日期">
                <template slot-scope="scope">
                  <span>{{ scope.row.createdate | formatDate }}</span>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="状态" width="80">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="handleDetail(scope.row)"
                    >查看订单</el-button
                  >
                </template>
              </el-table-column>
            </el-table>

            <!-- 分页 start -->
            <div class="pagination_wrap flex-rowc">
              <el-pagination
                @current-change="handleCurrentChange"
                layout="prev, pager, next, jumper"
                :page-size="20"
                :total="listTotalOne"
              >
              </el-pagination>
            </div>
            <!-- 分页 end -->
          </el-tab-pane>
        </el-tabs>
      </template>
      <div class="no_data flex-rowc" v-else>
        <el-button type="primary" @click="handleGo"
          >创建企业/团队名片</el-button
        >
        <el-button type="primary" @click="handleGo">加入企业or团队</el-button>
      </div>
    </div>
  </div>
</template>
<script>
// getExportUser
import { encryptstringadd } from "../api/api";
import { getQyUserList } from "../api/user";
import { mapState } from "vuex";
export default {
  name: "dataPage",
  data() {
    return {
      loading: false,
      activeName: "first",
      tabListOne: [],
      listTotalOne: 0,
      labelTwo: "加入申请",
      tabListTwo: [],
      listTotalTwo: 0,
      params: {
        appid: "",
        Page: 1,
        PageSize: 20,
        keyword: "",
      },
      downloadUrl: "",
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  computed: {
    ...mapState(["OPENID", "USERINFO"]),
  },
  created() {
    let { USERINFO } = this.$store.state;

    if (USERINFO.qy) {
      this.params.appid = USERINFO.qy ? USERINFO.qy.appid_business : "";
      this.getQyUserList();
      this.downloadUrl = `https://shop.winksshowp.com/service/excel/excel.aspx?act=export&code=50vFkV9WCMAuKg2g7hcHD5WE&appid=${USERINFO.qy.postappid}`;
    }
  },
  methods: {
    handleTab(tab) {
      if (tab.index == 0) {
        this.getQyUserList();
      }
    },

    //   获取用户列表数据
    getQyUserList() {
      this.loading = true;
      getQyUserList(this.params).then((res) => {
        this.tabListOne = res.list;
        this.listTotalOne = res.total;
        this.loading = false;
      });
    },

    // 分页
    handleCurrentChange(e) {
      this.params.Page = e;
      this.getQyUserList();
    },

    handleDownload() {
      // location.href = downloadUrl
      // 创建一个临时的 <a> 标签
      const link = document.createElement("a");
      link.href = this.downloadUrl;
      link.download = "file.xls"; // 设置下载时的文件名

      // 触发点击事件下载文件
      link.click();
    },
    handleGo() {
      this.$router.push("/mine");
    },

    handleDetail(item) {
      console.log(item,);
      
      this.encryptstringadd("dOrderList", {
        openid: item.guid,
      });
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },
  },
};
</script>
  <style lang="less" scoped>
.userListPage {
  .main_container {
    height: calc(100vh - 180px);
    margin: 20px auto;
    position: relative;
    .no_data {
      position: absolute;
      top: 30%;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  /deep/ .el-tabs__item {
    position: relative;
    .badge {
      position: absolute;
      font-size: 12px;
      color: red;
      top: -8px;
    }
  }
  /deep/ .el-table .cell {
    position: relative;
    .badge_round {
      display: inline-block;
      width: 5px !important;
      height: 5px !important;
      border-radius: 50%;
      background: red;
      position: absolute;
      top: 3px;
    }
  }
  .red {
    color: red;
    font-size: 12px;
  }
}
</style>